import { User, Roles } from '../store/api/apiTypes';

export { default as constants } from './constants';

export const getErrorMessageFromState = (state: any) => {
    if (state === undefined || state.error === undefined) {
        return undefined;
    }
    if (state.error.data && state.error.data.data && state.error.data.data.validation) { // validation error ?
        let message = '';
        let key: any;
        // tslint:disable-next-line:forin
        for (key in state.error.data.data.validation) {
            const value = state.error.data.data.validation[key];
            message += value.field + ': ' + value.message;
        }
        return message;
    }
    if (state.error && state.error.data && state.error.data.message) {
        return state.error.data.message;
    }

    return (state.error.message ? state.error.message : 'Une erreur est survenue, veuillez réessayer plus tard ou contacter un administrateur');
};

export const getSectionById = (sectionId?: string, sections?: any) => {
    if (sections.data && sections.data.items) {
        for (const s of sections.data.items) {
            if (sectionId === s.id) {
                return s;
            }
            for (const c of s.children) {
                if (sectionId === c.id) {
                    return c;
                }
            }
        }
    }
    return undefined;
};

export const getFullName = (firstname?: string, lastname?: string) => {
    if (!firstname && !lastname) {
        return '';
    }

    return `${firstname || ''}${lastname ? ` ${lastname}` : ''}`.trim();
};

export const capitalize = (str: string) => {
    if (typeof str !== 'string') {
        return '';
    }

    const lowerCased = str.toLowerCase();

    return `${lowerCased.charAt(0).toUpperCase()}${lowerCased.slice(1)}`;
};

export const capitalizeWords = (str: string) => {
    if (typeof str !== 'string') {
        return '';
    }

    return str.split(' ').map(capitalize).join(' ');
};

export const hasOwnProp = (obj: object, value: string | number | [], strict = true) => {
    let result = false;

    if (typeof obj === 'object') {
        if (Array.isArray(value)) {
            result = strict ?
                !value.some((property) => !Object.prototype.hasOwnProperty.call(obj, property)) :
                value.some((property) => Object.prototype.hasOwnProperty.call(obj, property));
        } else {
            result = Object.prototype.hasOwnProperty.call(obj, value);
        }
    }

    return result;
};

export const isAdmin = (user?: User) => {
    if (user && user.role === Roles.admin) {
        return true;
    }
    return false;
};

export const canManageFiles = (user?: User) => {
    if (user && (user.role === Roles.admin || user.role === Roles.manager)) {
        return true;
    }
    return false;
};

export const getUserRoleColor = (role: Roles) => {
    switch (role) {
        case Roles.admin:
            return 'purple';
        case Roles.manager:
            return 'orange';
        case Roles.user:
            return 'blue';
        case Roles.signup:
            return 'green';
        default:
            return 'grey';
    }
};

export const getUserRoleName = (role: Roles) => {
    switch (role) {
        case Roles.admin:
            return 'Administrateur';
        case Roles.manager:
            return 'Gestionnaire';
        case Roles.user:
            return 'Utilisateur';
        case Roles.signup:
            return 'Nouvel Inscrit';
        default:
            return '';
    }
};
